import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', () => {
    const narrativeText = document.querySelector('.overview-text .ot-desc');

    if (narrativeText) {
        const textContent = narrativeText.innerHTML.trim();
        const wordsArray = textContent.split(/\s+/);
        narrativeText.innerHTML = '';

        wordsArray.forEach(word => {
            if (word === '<br>') {
                const br = document.createElement('br');
                narrativeText.appendChild(br);
            } else {
                const span = document.createElement('span');
                span.textContent = word + ' ';
                span.classList.add('word');
                narrativeText.appendChild(span);
            }
        });
    }

    if (document.querySelector('.overview-text .ot-desc')) {
        document.querySelectorAll('.ot-desc').forEach((element) => {
            const elementWords = element.querySelectorAll('.word');

            gsap.fromTo(
                elementWords,
                {
                    opacity: 0.8,
                    fontWeight: 400,
                    color: '#ffffff',
                },
                {
                    opacity: 1,
                    fontWeight: 400,
                    color: '#BCFBBA',
                    duration: 2,
                    ease: 'power1.out',
                    stagger: 0.4,
                    scrollTrigger: {
                        trigger: element,
                        start: 'top center',
                        end: 'bottom 50%',
                        scrub: 3,
                        markers: false,
                        toggleActions: 'play play reverse reverse',
                    },
                },
            );
        });
    }
});
